import { IDataTableColumn } from '@srm/ui/data-table';
import { IDataGridColumnDescription } from '@models/response/IGridDescriptionResponse';
import { ValueType } from '@srm/ui/types/ValueType';
import { IDataGridCellDeps } from './cellLink';
import StatusCell from './parts/StatusCell';
import ValueCell from './parts/ValueCell';
import { DataGridRow } from './dataGridSchema';

export type { IDataGridCellDeps } from './cellLink';
export { linkedDocHrefOf } from './cellLink';

/**
 * Рендеры ячеек серверного списка поверх колонок схемы: значение по типу поля,
 * статус-колонка чипом, шаблоны из схемы (`dxGridCellTemplate`) от потребителя.
 */
export function applyDataGridCellRender(
    column: IDataTableColumn<DataGridRow>,
    description: IDataGridColumnDescription | undefined,
    deps: IDataGridCellDeps,
): IDataTableColumn<DataGridRow> {
    const type = description?.dataType ?? ValueType.Text;

    const template = description?.dxGridCellTemplate ? deps.cellTemplates?.[description.dxGridCellTemplate] : undefined;
    if (template) return { ...column, render: template, cellText: () => '' };

    if (description?.isStatusColumn) {
        return {
            ...column,
            wrapMode: 'wrap',
            minWidth: Math.max(column.minWidth ?? 0, 140),
            render: (row) => <StatusCell row={row} field={column.field} deps={deps} />,
        };
    }

    return {
        ...column,
        render: (row) => <ValueCell row={row} field={column.field} type={type} description={description} deps={deps} />,
    };
}
